import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import {
    FlexibleWidthXYPlot,
    XAxis,
    YAxis,
    HorizontalGridLines,
    LineSeries,
    Crosshair
} from 'react-vis';

const styles = {
    hint: {
        background: 'black',
        borderRadius: '5px',
        padding: '5px',
        color: 'white',
        textAlign: 'center',
        width: '190px'
    },
    addButton: {
        position: 'absolute',
        bottom: '50px',
        right: '50px'
    }
};

class UsageChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            crosshair: [{}],
            values: [],
            ...this.genState(props)
        };
    }

    genState = (props) => {
        const { statistics } = props;
        if (statistics === undefined || statistics.values === undefined) {
            return;
        }
        const values = statistics.values.map(entry => ({
            x: new Date(entry.date),
            y: entry.count || 0
        }));
        return { values, crosshair: [{}] };
    }

    componentWillReceiveProps = (props) => {
        this.setState(this.genState(props));
    }

    onMouseLeave = () => this.setState({ crosshair: [{}] });

    onNearestX = (value, { index }) => {
        this.setState({ crosshair: [this.state.values[index]] });
    }

    render() {
        const { values, crosshair } = this.state;
        const { width } = this.props;
        return (
            <Grid item md={width || 6} sm={12}>
                <FlexibleWidthXYPlot
                    animation
                    height={300}
                    xType="time"
                    onMouseLeave={this.onMouseLeave}
                >
                    <HorizontalGridLines />
                    <XAxis title="Time" position="start" tickLabelAngle={-45} />
                    <YAxis title="Usage" />
                    <LineSeries
                        className="first-series"
                        data={values}
                        onNearestX={this.onNearestX}
                    // curve={'curveMonotoneX'}
                    />
                    {crosshair[0].x && <Crosshair values={crosshair}>
                        <div style={styles.hint}>
                            {crosshair[0].x.toLocaleString()}: {crosshair[0].y.toFixed(2)}
                        </div>
                    </Crosshair>}
                </FlexibleWidthXYPlot>
            </Grid>
        );
    }
}

export default withStyles(styles)(UsageChart);